module.exports = "<span class=\"brudcrums\" style=\"font-size:14px\">\r\n    <a [routerLink]=\"['/Dashboard']\"><img src=\"../.../../Content/images/Home.png\" class=\"homeicon\">  </a>\r\n<span *ngIf=\"currentPage!=='Dashboard'\">  |   {{currentPage}}</span>\r\n</span>"


//////////////////
// WEBPACK FOOTER
// ./app/shared/breadcrumb/Breadcrumb.template.html
// module id = 601
// module chunks = 3